<!-- App.vue -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  /* 防止数据丢失 */
  async mounted() {
    //
    const storeInfo = sessionStorage.getItem("jr_adminStore");

    /* 在页面加载时读取sessionStorage里的状态信息 */
    if (storeInfo) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(storeInfo))
      );
    }
    /* 在页面刷新时将vuex里的信息保存到sessionStorage里 */
    window.addEventListener("beforeunload", () => {
      //
      sessionStorage.setItem(
        "jr_adminStore",
        JSON.stringify(this.$store.state)
      );
    });
  },
};
</script>

<style lang="scss">
@import "@css/base.css";
@import "@css/common.css";
@import "@css/element-ui.css";
@import "@css/iview.css";

// .el-form-item__content {
//   line-height: normal !important;
// }
</style>
